/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2251
 */

!function () {
  "use strict"

  exports.ast = require(/* 2252 */"./2252")
  exports.code = require(/* 1364 */"./1364")
  exports.keyword = require(/* 2253 */"./2253")
}()
